<div class="d-none">{{ T.SHARED_AUDIO_PLAYER_TRAINING_ROOM | translate }} {{ trainingRoomId() }}</div>
